// Definição para o modal de busca de Locais de Estoque
// Factory function - recebe idOrganizacao (organização ativa) como parâmetro, sem magic strings
// Filtra por Tipo Local (aceita string única ou array de strings) e Status = Ativo
//
// IMPORTANTE (default seguro): o 3º parâmetro é uma lista VAZIA ([]). Ou seja, quando
// o chamador NÃO informa tipos, nenhum filtro de tipo é aplicado e o modal mostra
// TODOS os locais da organização. Isso evita que a omissão do 3º argumento restrinja
// a busca a um subtipo inesperado (ex.: Trânsito). Para restringir, passe os códigos
// explicitamente (ex.: [ESTQ_TIPO_LOCAL_ESTOCAGEM.Transito]).
// O Tipo Local também pode ser escolhido dinamicamente via filtro CampoBuscaLista

import { ST } from '@/constants/ST'

export const criarConfigBuscaLocalEstoque = (idOrganizacao, idFilial, lstTiposLocais = []) => {
  // Normaliza para array (aceita string única ou array)
  const tipos = Array.isArray(lstTiposLocais) ? lstTiposLocais : [lstTiposLocais]

  return {
    label: 'Local Estoque',
    placeholder: 'ID ou Descrição...',
    titulo: 'Selecionar Local de Estoque',
    tamanho: 'xl',
    endpointApi: 'LocaisEstoque',
    idField: 'idLocalEstoque',
    displayField: 'idLocalEstoque',
    descField: 'descricao',
    tabela: 'LocalEstoque',
    camposFiltro: [
      { label: 'Descrição', model: 'busca', tipo: 'text' },
      { label: 'Tipo de Local', model: 'lstTipoLocal', tipo: 'listabusca', tabela: 'LocalEstoque' }
    ],
    colunasGrid: [
      { header: 'ID', dataField: 'idLocalEstoque', width: '8%' },
      { header: 'Descrição', dataField: 'descricao', width: '30%' },
      { header: 'Filial', dataField: 'filial', width: '20%' },
      { header: 'Tipo de Local', dataField: 'lstTipoLocal', width: '20%' },
      { header: 'Status', dataField: 'lstStatusLocalEstoque', width: '12%' }
    ],
    filtrosFixos: {
      idFilial,
      ...(tipos.length > 0 ? { lstTipoLocal: tipos } : {}),
      lstStatusLocalEstoque: ST.Ativo
    }
  }
}
